export default "__VITE_ASSET__DK9c_dj6__"